import { padInt } from "./padInt";
import { randomInt } from "./randomInt";

const WORDS = [
  "part",
  "camp",
  "pour",
  "cake",
  "oral",
  "wire",
  "dark",
  "soul",
  "glow",
  "navy",
  "wave",
  "wrap",
  "disk",
  "jest",
  "drag",
  "flex",
  "dome",
  "soft",
  "tune",
  "fame",
  "warm",
  "wait",
  "poll",
  "rice",
  "dose",
  "cook",
  "shot",
  "heir",
  "copy",
  "lost",
  "lake",
  "deny",
  "sick",
  "take",
  "lump",
  "rise",
  "sigh",
  "rush",
  "fold",
  "beer",
  "mine",
  "beef",
  "duty",
  "raid",
  "maze",
  "link",
  "lick",
  "seed",
  "talk",
  "user",
  "cord",
  "boot",
  "moon",
  "help",
  "rest",
  "salt",
  "food",
  "pile",
  "shed",
  "glow",
  "inch",
  "turn",
  "wind",
  "lack",
  "dish",
  "left",
  "coat",
  "save",
  "case",
  "lend",
  "brag",
  "sick",
  "frog",
  "hero",
  "thin",
  "long",
  "rise",
  "roof",
  "edge",
  "sell",
  "ride",
  "trap",
  "rule",
  "solo",
  "maze",
  "dash",
  "miss",
  "yard",
  "seat",
  "wild",
  "face",
  "slab",
  "coin",
  "sail",
  "flag",
  "gold",
  "gear",
  "ally",
  "pack",
  "bird",
  "rice",
  "high",
  "hook",
  "meal",
  "home",
  "rock",
  "rule",
  "boot",
  "live",
  "cute",
  "tube",
  "draw",
  "loud",
  "half",
  "bury",
  "rung",
  "fill",
  "spit",
  "hang",
  "full",
  "will",
  "sick",
  "hike",
  "wolf",
  "lace",
  "herd",
  "snap",
  "dark",
  "mask",
  "hero",
  "pack",
  "tree",
  "sign",
  "side",
  "rack",
  "able",
  "dive",
  "dump",
  "film",
  "keep",
  "sell",
  "hold",
  "book",
  "ring",
  "soar",
  "slip",
  "hour",
  "zero",
  "seek",
  "zone",
];

export function generateRoomName() {
  return [
    WORDS[randomInt(WORDS.length)],
    WORDS[randomInt(WORDS.length)],
    padInt(randomInt(100), 3),
  ].join("-");
}
